module.exports = __webpack_public_path__ + "img/icon-call.db718bca.svg";